export enum IndirectTaxCredentialType {
  INDIRECT_TAX_REGISTRATION = 'INDIRECT_TAX_REGISTRATION',
  OTHER = 'OTHER',
}

export enum IndirectTaxCredentialStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
}

export enum IndirectTaxCredentialBlockType {
  String = 'String',
  SecureString = 'SecureString',
  File = 'File',
}

export interface IIndirectTaxCredentialBlockInput {
  id?: string;
  blockKey: string;
  blockLabel: string;
  blockType: IndirectTaxCredentialBlockType;
  value: string;
}

export interface IIndirectTaxCredentialBlock {
  id: string;
  blockKey: string;
  blockLabel: string;
  blockType: IndirectTaxCredentialBlockType;
  value: string | null;
  displayOrder?: number;
}

export interface IIndirectTaxCredentialResponse {
  id: string;
  corporationId?: string;
  portalId?: string;
  credentialType: IndirectTaxCredentialType;
  isCustom?: boolean;
  name?: string;
  portalUrl?: string;
  notes?: string;
  status: IndirectTaxCredentialStatus;
  blocks: IIndirectTaxCredentialBlock[];
  createdAt: string;
  updatedAt: string;
}

export interface ICreateIndirectTaxCredentialParams {
  corporationId: number;
  credentialType: IndirectTaxCredentialType;
  portalId?: string;
  isCustom?: boolean;
  name?: string;
  portalUrl?: string;
  notes?: string;
  blocks: IIndirectTaxCredentialBlockInput[];
}

export interface ICreateIndirectTaxCredentialResponse {
  credential: {
    id: string;
  };
  message: string;
}

export interface IIndirectTaxBulkCredentialInput {
  credentialType: IndirectTaxCredentialType;
  portalId?: string;
  isCustom?: boolean;
  name?: string;
  portalUrl?: string;
  notes?: string;
  blocks: IIndirectTaxCredentialBlockInput[];
}

export interface ICreateIndirectTaxCredentialsBulkParams {
  corporationId: number;
  credentials: IIndirectTaxBulkCredentialInput[];
}

export interface IIndirectTaxBulkCredentialResult {
  id: string;
  success: boolean;
}

export interface ICreateIndirectTaxCredentialsBulkResponse {
  credentials: IIndirectTaxBulkCredentialResult[];
  message: string;
}

export interface IGetIndirectTaxCredentialParams {
  corporationId: number;
}

export interface IGetIndirectTaxCredentialResponse {
  credential: IIndirectTaxCredentialResponse;
  message: string;
}

export interface IUpdateIndirectTaxCredentialParams {
  corporationId: number;
  portalId?: string;
  name?: string;
  portalUrl?: string;
  notes?: string;
  status?: IndirectTaxCredentialStatus;
  blocks?: IIndirectTaxCredentialBlockInput[];
  blocksToDelete?: string[];
}

export interface IUpdateIndirectTaxCredentialResponse {
  credential: {
    id: string;
    updatedAt: string;
  };
  message: string;
}

export interface IDeleteIndirectTaxCredentialParams {
  corporationId: number;
}

export interface IDeleteIndirectTaxCredentialResponse {
  credential: {
    id: string;
    deleted: boolean;
  };
  message: string;
}

export type IGetIndirectTaxCredentialAdminResponse =
  IGetIndirectTaxCredentialResponse;

export interface IIndirectTaxPortalDetails {
  portalId: string;
  portalName: string;
  portalUrl?: string;
  country: string;
  stateOrProvince?: string;
}

export interface IIndirectTaxCredentialWithPortal
  extends IIndirectTaxCredentialResponse {
  portalDetails?: IIndirectTaxPortalDetails;
}

export interface IListIndirectTaxCredentialsParams {
  corporationId: number;
  portalIds?: string[];
  extendPortalDetails?: boolean;
  includeInactive?: boolean;
}

export interface IListIndirectTaxCredentialsResponse {
  credentials: IIndirectTaxCredentialWithPortal[];
  count: number;
  message: string;
}
